var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInternshipFarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.788,
    height: 27.526,
    viewBox: "0 0 35.788 27.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1075",
    "data-name": "Groupe 1075",
    transform: "translate(-5037.199 -1142.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1071",
    "data-name": "Groupe 1071",
    transform: "translate(5041.876 1142.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10745",
    "data-name": "Trac\\xE9 10745",
    d: "M5076.249,1154.464l-2.708-7.645-9.22-2.777-9.22,2.777-2.708,7.645a.337.337,0,0,1-.43.2l-.634-.225a.336.336,0,0,1-.2-.429l2.821-7.967a.675.675,0,0,1,.44-.419l9.741-2.933a.669.669,0,0,1,.389,0l9.74,2.933a.674.674,0,0,1,.44.419l2.821,7.967a.336.336,0,0,1-.2.429l-.634.225A.336.336,0,0,1,5076.249,1154.464Z",
    transform: "translate(-5051.105 -1142.667)",
    fill: "#f6c459"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1072",
    "data-name": "Groupe 1072",
    transform: "translate(5043.923 1145.095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10746",
    "data-name": "Trac\\xE9 10746",
    d: "M5071.073,1183.408l2.966,5.8,2.967-5.8Z",
    transform: "translate(-5066.403 -1172.131)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10747",
    "data-name": "Trac\\xE9 10747",
    d: "M5069.389,1198.308l2.966-5.8-2.966-5.8Z",
    transform: "translate(-5065.285 -1174.319)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10748",
    "data-name": "Trac\\xE9 10748",
    d: "M5095.044,1207.247l-2.966,5.8h5.933Z",
    transform: "translate(-5080.342 -1187.952)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10749",
    "data-name": "Trac\\xE9 10749",
    d: "M5074.04,1207.247l-2.967,5.8h5.933Z",
    transform: "translate(-5066.403 -1187.952)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10750",
    "data-name": "Trac\\xE9 10750",
    d: "M5091.9,1199.269l2.461-4.814-2.461-4.814Z",
    transform: "translate(-5080.221 -1176.268)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10751",
    "data-name": "Trac\\xE9 10751",
    d: "M5092.078,1183.408l2.966,5.8,2.966-5.8Z",
    transform: "translate(-5080.342 -1172.131)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10752",
    "data-name": "Trac\\xE9 10752",
    d: "M5079.448,1159.909l-2.65-7.481-8.44-2.543-8.44,2.543-2.647,7.481-.081.229v14.844h3.095V1161.5a1.347,1.347,0,0,1,1.346-1.346h13.458a1.347,1.347,0,0,1,1.345,1.346v13.485h3.095v-14.844Zm-11.09-2.614a1.985,1.985,0,1,1,1.984-1.985A1.986,1.986,0,0,1,5068.358,1157.3Z",
    transform: "translate(-5057.19 -1149.885)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10753",
    "data-name": "Trac\\xE9 10753",
    d: "M5084.038,1199.267v-9.63l-2.462,4.815Z",
    transform: "translate(-5073.373 -1176.265)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10754",
    "data-name": "Trac\\xE9 10754",
    d: "M5105.548,1198.306V1186.7l-2.967,5.8Z",
    transform: "translate(-5087.313 -1174.316)",
    fill: "#f6c459"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1073",
    "data-name": "Groupe 1073",
    transform: "translate(5037.199 1161.297)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1701",
    "data-name": "Rectangle 1701",
    width: 1.682,
    height: 8.895,
    transform: "translate(0 0)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1702",
    "data-name": "Rectangle 1702",
    width: 5.884,
    height: 1.682,
    transform: "translate(0.841 1.454)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1703",
    "data-name": "Rectangle 1703",
    width: 5.884,
    height: 1.682,
    transform: "translate(0.841 5.009)",
    fill: "#f6c459"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1074",
    "data-name": "Groupe 1074",
    transform: "translate(5066.262 1161.297)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1704",
    "data-name": "Rectangle 1704",
    width: 1.682,
    height: 8.895,
    transform: "translate(5.043 0)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1705",
    "data-name": "Rectangle 1705",
    width: 5.884,
    height: 1.682,
    transform: "translate(0 1.454)",
    fill: "#f6c459"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1706",
    "data-name": "Rectangle 1706",
    width: 5.884,
    height: 1.682,
    transform: "translate(0 5.009)",
    fill: "#f6c459"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternshipFarm);
export default __webpack_public_path__ + "static/media/internship_farm.a1c2c33319c86e6163f3783cd5bbc23e.svg";
export { ForwardRef as ReactComponent };